//httpConfig.interceptor.ts
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { LoadingController } from '@ionic/angular';
import { Globals } from './globals';


@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
  loaderToShow: any;
  isLoading;
  requestCount: number = 0;
  constructor(
    public loadingController: LoadingController,
    public globals : Globals
    ) {}


  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    this.requestCount++;
    //console.log('>>RequestCount:',this.requestCount);
    //this.globals.setIsLoading(true);
    this.globals.incrementLoadingRequests();

    //this.showLoader();
    let urlPath = new URL(request.url).pathname;
    this.globals.incrementLoadingArr(urlPath);

    return next.handle(request).pipe(

      map((event: HttpEvent<any>) => {
        //console.log('request--->>>', request);
        //console.log('request URL--->>>', request.url);
        //console.log('request URL--->>>', urlPath);

        if (event instanceof HttpResponse) {
          //console.log('event--->>>', event);
          this.requestCount--;
          this.globals.decrementLoadingRequests();
          this.globals.decrementLoadingArr(urlPath);
        }
        //this.globals.setIsLoading(false);
        this.hideLoader();
        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        console.error(error);
        this.requestCount--;
        //this.globals.setIsLoading(false);
        this.globals.decrementLoadingRequests();
        this.globals.decrementLoadingArr(urlPath);
        this.hideLoader();
        return throwError(error);
      }));
  }

  showLoader() {
    this.loaderToShow = this.loadingController.create({
      message: 'Processing Server Request ' + this.requestCount
    }).then((res) => {
      res.present();
      res.onDidDismiss().then((dis) => {
        //console.log('Loading dismissed!');
      });
    });
    this.hideLoader();
  }

  hideLoader() {
    this.loadingController.getTop().then(v => v ? this.doStopLoader() : null);
  }
  doStopLoader(){
    //this.globals.decrementLoadingRequests();
    this.loadingController.dismiss();
  }


}
